import { faBuildingColumns } from '@fortawesome/free-solid-svg-icons/faBuildingColumns';
import { FieldLabelIconMui5 } from 'components/atoms/FieldLabelIcon';
import {
  SelectControl,
  SelectField,
  SelectLabel,
  SelectOption,
} from 'components/atoms/Select';
import {
  SetFilterValue,
  useFilters,
} from '../../../../../services/filters/hooks/useFilters';
// import { useStyles } from '../styles';
import {
  TierNames,
  TierScore,
  TierScoreMap,
  TierScoreValueMap,
} from 'shared/types/models';
import { useRecoilValue } from 'recoil';
import { userAtom } from 'recoil/atoms';
import {
  getCreditTierByScore,
  getUserCreditScore,
} from 'shared/utils/functions';
import { labelInputStyles } from '../styles';

export const CreditTierFilter = ({
  setFilterValue,
  disabled = false,
}: {
  setFilterValue: SetFilterValue;
  disabled?: boolean;
}) => {
  const user = useRecoilValue(userAtom);
  const { filters } = useFilters();
  let value = getUserCreditScore(user, filters?.creditScore);

  const creditTier = getCreditTierByScore(value);
  const tierScore = TierScoreMap[creditTier?.name];

  value = TierScoreValueMap[tierScore];

  const disabledSelect = Boolean(getUserCreditScore(user, null));

  return (
    <SelectControl fullWidth>
      <SelectLabel sx={labelInputStyles}>
        <FieldLabelIconMui5 icon={faBuildingColumns} color='primary' />
        Credit tier
      </SelectLabel>
      <SelectField
        variant='outlined'
        disabled={disabledSelect}
        displayEmpty
        onChange={(e) => {
          if (disabled) {
            return;
          }
          setFilterValue('creditScore', Number(e.target.value));
        }}
        value={value}
        label='Credit tier'
      >
        {Object.keys(TierNames).map((key) => (
          <SelectOption key={key} value={TierScoreValueMap[TierScore[key]]}>
            <b>{TierNames[key]}:</b>&nbsp;
            <i style={{ color: '#aaa' }}>{TierScore[key]}</i>
          </SelectOption>
        ))}
      </SelectField>
    </SelectControl>
  );
};
